'use strict';

var createEnum = require('../enums/createEnum');

module.exports = createEnum(['AUTOMATIC', 'PL_DATA', 'PROMO_OFFERING', 'ADVANCED_MARKETING', 'ORDER_LEVEL', 'PL_DATA_DATE']);